"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("react-quill/dist/quill.snow.css");
var mutil_Language_1 = require("mobile/utils/mutil-Language");
var s = require("./index.scss");
var RichText = (function (_super) {
    __extends(RichText, _super);
    function RichText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RichText.prototype.render = function () {
        var _a = this.props, moduleDetail = _a.moduleDetail, commonProps = _a.commonProps, addModuleMap = _a.addModuleMap, index = _a.index;
        var textModule, bgColor = "#fff";
        if (moduleDetail) {
            textModule = moduleDetail.module;
            bgColor = moduleDetail.ui && moduleDetail.ui.bgColor && moduleDetail.ui.bgColor;
        }
        return (React.createElement("div", { ref: function (node) {
                if (node) {
                    addModuleMap(index, node, "#" + commonProps.id);
                }
            } },
            React.createElement(React.Fragment, null, moduleDetail && textModule ? (React.createElement("div", { className: s.RichText, dangerouslySetInnerHTML: { __html: mutil_Language_1.multilingualTextDisplay(textModule) }, style: { backgroundColor: bgColor } })) : null)));
    };
    return RichText;
}(React.Component));
exports.default = RichText;
